var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 42069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 42059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 42061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.668 4.03125C20.9879 4.03125 20.5344 4.48466 20.5344 5.16477V7.43182H22.8015V5.16477C22.8015 4.48466 22.3481 4.03125 21.668 4.03125ZM10.3327 4.03125C9.65263 4.03125 9.19922 4.48466 9.19922 5.16477V7.43182H11.4663V5.16477C11.4663 4.48466 11.0129 4.03125 10.3327 4.03125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.9349 28.9666H8.06561C6.25197 28.9666 4.66504 27.4112 4.66504 25.3771V11.0192C4.66504 9.10478 6.13862 7.42969 8.06561 7.42969H23.9349C25.7486 7.42969 27.3355 8.98513 27.3355 11.0192V25.4968C27.3355 27.4112 25.8619 28.9666 23.9349 28.9666Z",
    fill: "#FC5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.3355 10.832H4.66504V13.0991H27.3355V10.832Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 42060"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1336",
    x: 12.0742,
    y: 18.668,
    width: 2.10026,
    height: 9.00501,
    rx: 1.05013,
    transform: "rotate(-45 12.0742 18.668)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1337",
    width: 2.10026,
    height: 9.00501,
    rx: 1.05013,
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 19.9268 18.668)",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelVisit);
export default __webpack_public_path__ + "static/media/cancel-visit.e8ebbd621eb9d2de0d3df6b7c483e349.svg";
export { ForwardRef as ReactComponent };